import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/src/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#182D4F",
        secondary: "#424242",
        accent: "#862930",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  },
  breakpoint: {
    thresholds: {
      sm: 1200,
      md: 1400
    }
  }
});
